import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getClientPassportInfo = async (clientId) => {
  return await request.get(
    `/HousingStock/client/documents/passport/${clientId}`,
    {},
    'При загрузке паспортных данных произошла ошибка',
    []
  );
};

const useClientPassportInfo = (clientId, options = {}) => {
  return useQuery(
    getQueryKeys.clientPassportInfo(clientId),
    () => getClientPassportInfo(clientId),
    options
  );
};

export default useClientPassportInfo;
